export const AppEndpointKeys = {
  AUTHORIZER: import.meta.env.APP_AUTHORIZER_AUTH_URL,
  BASE_API: import.meta.env.APP_BASE_API_URL,
  PUBLIC: import.meta.env.APP_PUBLIC_URL,
  MSAL: import.meta.env.APP_MSAL_AUTHORITY_URL,
  MSAL_POST_LOGIN: import.meta.env.APP_MSAL_POST_LOGIN_URL,
  MSAL_POST_LOGOUT: import.meta.env.APP_MSAL_POST_LOGOUT_URL,
} as const;

export type AppEndpointKey = keyof typeof AppEndpointKeys;
export type AppEndpointValue = (typeof AppEndpointKeys)[AppEndpointKey];
